module.exports = __webpack_public_path__ + "img/juho-wolt.6dcb7a6c.jpg";